// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.height-initial {
  height: initial;
}

.catalog-card-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.search-details-card-width {
  width: 100%;
}

.search-review-modal-width-product {
  width: 600px;
}

.search-review-modal-width-catalog {
  width: 90vw;
}

`, "",{"version":3,"sources":["webpack://./client/components/dashboard/SearchOps/SubViews/subViews.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb","sourcesContent":[".height-initial {\n  height: initial;\n}\n\n.catalog-card-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.search-details-card-width {\n  width: 100%;\n}\n\n.search-review-modal-width-product {\n  width: 600px;\n}\n\n.search-review-modal-width-catalog {\n  width: 90vw;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
